/**
 * IMPORTS
 */
import type { SecaoDetalhesRemessa } from "@components/modal-detalhes-remessa";

import { montarSecoesDetalhesRemessaExpedicao } from "@pages/expedicao/dashboard/helpers/montar-secoes-detalhes-remessa-expedicao";

/**
 * Monta as seções do modal de detalhes a partir de uma linha da tabela de recepção.
 * Reaproveita as seções da expedição e acrescenta o que a expedição registrou ao liberar.
 */
function montarSecoesDetalhesRemessaRecepcao(linha: Record<string, any>): SecaoDetalhesRemessa[] {
  const liberacao = linha.liberacao_expedicao;

  return [
    ...montarSecoesDetalhesRemessaExpedicao(linha),
    {
      titulo: "Liberação da expedição",
      campos: [
        { label: "Observação", value: liberacao?.observacao },
        { label: "Outros", value: liberacao?.outros },
      ],
    },
  ];
}

/**
 * EXPORTS
 */
export { montarSecoesDetalhesRemessaRecepcao };
